import { MaterializeAction } from 'angular2-materialize';
import { Component, OnInit, HostListener, EventEmitter, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { ILookup } from '../shared/lookup';
import { ICompany } from './company.model';
import { Router, ActivatedRoute } from '@angular/router';
import { AddressBookService } from './address-book.service';
import { AppService } from '../app.service';
import { AuthService } from '../shared/core/index';
import { FormBuilder } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';
import { IAddressBookSearchData } from './address-book-search-data.model';
import { Observable } from 'rxjs/Observable';
import { Location } from "@angular/common"
import { SharedUtils } from '../shared/utils';
import { GlobalErrorHandler } from '../shared/core/error-handler';
import { PromptOptions, ModalPromptService } from '../shared/helper-components/modal-prompt.service';
import clipboard from 'clipboard-polyfill';
import { NotificationsService, Notification } from '../shared/helper-components/index'
import { Subscription, ISubscription } from 'rxjs/Subscription';

declare var Materialize: any;
@Component({
    selector: 'address-book',
    template: require('./address-book.component.html')

})
export class AddressBookComponent implements OnInit, AfterViewInit {

    @ViewChild('maincontainer') public maincontainer:ElementRef;
    @ViewChild('contactCard') public contactCard:ElementRef;

    sortByLookup: ILookup[] =
        [
            { id: "Name", name: 'A-Z', type: "" },
            { id: "ModifiedDate", name: 'Date Modified', type: "" }
        ];
    itemList: ICompany[] = [];
    showSpinner: boolean = false;
    listSearchData: IAddressBookSearchData;
    isLoadingMoreRecords: boolean = false;
    modalActions = new EventEmitter<string | MaterializeAction>();
    sortOrderTooltip = 'sort desc';
    sortOrderIcon = 'arrow_upward';
    filterMaterializeActions = new EventEmitter<string | MaterializeAction>();
    searchMessage: string = '';
    noRecordsFoundMessage: string = 'No items found with the provided filters.';

    constructor(private _router: Router,
        private _route: ActivatedRoute,
        private _addressBookService: AddressBookService,
        private _appService: AppService,
        private _authService: AuthService,
        private location: Location,
        private fb: FormBuilder,
        private _errorHandler: GlobalErrorHandler,
        private _prompt: ModalPromptService,
        private _notificationsService: NotificationsService,

    ) {
    }

    public ngOnInit() {
        this.listSearchData = new IAddressBookSearchData();
        // // Read the clearance Id from the route parameter
        var obsComb = Observable.combineLatest(this._route.params, this._route.queryParams,
            (params, qparams) => ({ params, qparams }))
        obsComb.subscribe(
            combine => {
                let companyIdParam = combine.qparams['companyId'];
                this.listSearchData.companyId = companyIdParam;
                this.listSearchData.sortOrder = 'ASC';
                let sortByParam = combine.qparams['sortBy'];
                if (sortByParam)
                    this.listSearchData.sortBy = sortByParam;
                let sortOrder = combine.qparams['sortOrder'];
                if (sortOrder)
                    this.listSearchData.sortOrder = sortOrder;
                let filterString = combine.qparams['filterString'];
                if (filterString)
                    this.listSearchData.filterString = filterString;

                this.filterChanged('onLoad');

            }
        );

        this._appService.scrollBottomReachedEvent.subscribe(()=>{
            this.loadMoreRecords();
        })
    }

    ngOnDestroy(): void {
        
        if (this.promptSubscription  && !this.promptSubscription.closed)
            this.promptSubscription.unsubscribe();
        
    }

    openFirst() {
        this.filterMaterializeActions.emit({ action: "collapsible", params: ['open', 0] });
    }

    closeFirst() {
        this.filterMaterializeActions.emit({ action: "collapsible", params: ['close', 0] });
    }
    ngAfterViewInit(): void {
        this.initMaterial();
        $('.tooltipped').tooltip({ delay: 50 });
        SharedUtils.RemoveTooltipIfNeeded();
        $('.collapsible').collapsible();
        if (SharedUtils.IsMobile()) {

            this.openFirst();
            setTimeout(() => {
                this.closeFirst();
            }, 1500);
        }
    }
    initMaterial() {
        Materialize.updateTextFields();
    }

    getCompanies(): void {
        this._addressBookService.getCompanies(this.listSearchData).subscribe
            (
            (data) => {
                if (!data.resultSet || data.resultSet.length == 0) {
                    this.searchMessage = this.noRecordsFoundMessage;
                }
                this.onListDataRetrieved(data);
                this.showSpinner = false;
            },
            (error: any) => {
                this.itemList = [];
                this.showSpinner = false;

                if (error.status == 404) {
                    this.searchMessage = this.noRecordsFoundMessage;
                } else {
                    this._errorHandler.processError(error);
                }
            }
            );
    }
    stopPropagation(e): void {
        e.stopPropagation();
    }
    selectAllItems(e): void {
        if (this.itemList) {
            if (e.target.checked) {
                this.itemList.forEach(it => it.isSelected = true);
            }
            else {
                this.itemList.forEach(it => it.isSelected = false);
            }
        }
    }
    @HostListener("window:scroll", ["$event"])
    public onWindowScroll() {
        if (this.isBottomReached()) {
            //code when scroll reached end
            console.log('scroll reached end');
            this.loadMoreRecords();
        }
    }
    isBottomReached(): Boolean {
        let windowHeight = "innerHeight" in window ? window.innerHeight
            : document.documentElement.offsetHeight;
        let body = document.body, html = document.documentElement;
        let docHeight = Math.max(body.scrollHeight,
            body.offsetHeight, html.clientHeight,
            html.scrollHeight, html.offsetHeight);
        let windowBottom = windowHeight + window.pageYOffset;
        if (windowBottom >= docHeight) {
            return true;
        }
        return false;
    }

    moreRecords(): boolean {
        if (!this.isLoadingMoreRecords) {
            let nextPageRecordStartIndex = this.listSearchData.pazesize + this.listSearchData.pageStartIndex;
            return this.listSearchData.totalNumberOfRecords > nextPageRecordStartIndex && nextPageRecordStartIndex < 2000
        }

        return false;
    }


    manualLoad():void{
        this.loadMoreRecords();
        setTimeout(() => {
            this.maincontainer.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'start' });
        });
    }

    loadMoreRecords(): void {
        if (!this.isLoadingMoreRecords) {
            let nextPageRecordStartIndex = this.listSearchData.pazesize + this.listSearchData.pageStartIndex;
            //if there are more records to fetch
            if (this.listSearchData.totalNumberOfRecords > nextPageRecordStartIndex && nextPageRecordStartIndex < 2000) {
                this.isLoadingMoreRecords = true;
                this.listSearchData.pageStartIndex = nextPageRecordStartIndex;
                this._addressBookService.getCompanies(this.listSearchData)
                    .subscribe
                    (
                    (data) => {
                        this.isLoadingMoreRecords = false;
                        if (data.resultSet) {
                            this.listSearchData.totalNumberOfRecords = data.totalNumberOfRecords;
                            this.listSearchData.pageStartIndex = data.pageStartIndex;
                            data.resultSet.forEach(it => this.itemList.push(it));

                            console.log(this.itemList.length);
                        }

                    },
                    (error: any) => {
                        this.isLoadingMoreRecords = false;
                        this.itemList = [];
                        if (error.status == 404) {

                        } else {
                            this._errorHandler.processError(error);
                        }

                    }
                    );
            }

        }
    }

    onListDataRetrieved(listSearchData: IAddressBookSearchData): void {
        console.log(listSearchData);
        this.itemList = [];
        if (listSearchData.resultSet) {
            listSearchData.resultSet.forEach(item => this.itemList.push(item));
            this.listSearchData.totalNumberOfRecords = listSearchData.totalNumberOfRecords;
            this.listSearchData.pageStartIndex = listSearchData.pageStartIndex;
        }
    }
    filterChanged(filterType: string): void {
        window.scrollTo(0, 0);

        if (filterType == 'sortOrder') {
            if (!this.listSearchData.sortOrder || this.listSearchData.sortOrder == 'ASC') {
                this.listSearchData.sortOrder = 'DESC';
                this.sortOrderIcon = 'arrow_downward';
                this.sortOrderTooltip = 'sort asc';
            }
            else {
                this.listSearchData.sortOrder = 'ASC';
                this.sortOrderIcon = 'arrow_upward';
                this.sortOrderTooltip = 'sort desc';
            }
        }
        else if (filterType == 'clear') {
            this.listSearchData.sortBy = this.sortByLookup[0].id;
            this.listSearchData.sortOrder = null;
            this.listSearchData.filterString = null;
        }

        this.listSearchData.pazesize = 15;
        this.listSearchData.pageStartIndex = 0;
        this.listSearchData.totalNumberOfRecords = 0;
        console.log(this.listSearchData);
        this.getCompanies();
        if (filterType != 'onLoad') {
            this.updateRouteURL();
        }
        this.collapseAll();
    }
    updateRouteURL(): void {
        let newUrl = '/addressbook';
        if (this.listSearchData.sortBy) {
            newUrl += '?sortBy=' + this.listSearchData.sortBy;
        }
        else {
            newUrl += '?sortBy=CreatedDate';
        }
        if (this.listSearchData.sortOrder) {
            newUrl += '&sortOrder=' + this.listSearchData.sortOrder;
        }

        if (this.listSearchData.filterString) {
            newUrl += '&filterString=' + this.listSearchData.filterString;
        }
        this.location.replaceState(newUrl);
        this._appService.listViewURL = newUrl;
        console.log(this._appService.listViewURL);

    }

    anyItemSelected(): boolean {
        return this.itemList && this.itemList.filter(it => it.isSelected).length > 0;
    }
    showCompanyDetail(companyId: string): void {
        this._router.navigate(['addressbook', companyId])
    }
    deleteCompanies(): void {
        var selectedItems = this.itemList.filter(it => it.isSelected);
        selectedItems.forEach(item =>
            this._addressBookService.deleteCompany(item.id)
                .subscribe(
                    (r) => {
                        var index = this.itemList.map(function (c) {
                            return c.id;
                        }).indexOf(item.id);
                        this.itemList.splice(index, 1);
                        if (r) {
                            console.log('deleteCompany(...) >> response: ' + JSON.stringify(r));
                        }
                        (error: any) => {
                            // console.error('deleteCompany(...) >> error:' + error);
                            this._errorHandler.processError(error);
                        }
                    }
                )
        );
        this.onDeleteComplete();
    }

    promptOptions: PromptOptions = { header: 'Delete Companies', body: '' };
    promptSubscription: ISubscription;

    openModal() {

        $(".collapsible").collapsible({ accordion: true });
        $(".collapsible").collapsible({ accordion: false });
        $('.collapsible').collapsible('close', 0);

        this.promptOptions.body = 'Are you sure you want to delete the selected Companies?';
        this.promptSubscription = this._prompt.openModal(null, true, this.promptOptions)
            .subscribe(
                answerIsYes => {
                    if (answerIsYes) {
                        this.deleteCompanies();
                        this.collapseAll();
                    }
                });

        return false;
    }
    collapseAll(): void {
        $(".collapsible").collapsible({ accordion: true });
        $(".collapsible").collapsible({ accordion: false });
        $('.collapsible').collapsible('close', 0);
    }

    onDeleteComplete(): void {
        console.log('onDeleteComplete() >>> finish');
        this._router.navigate(['addressbook']);
    }

    CopyClipboard(e): void{
        // console.log('e:' + e.innerHTML);
        let s = e.innerHTML;
        var dt = new clipboard.DT();

        //get the text version
        var temp = document.createElement("div");
        temp.innerHTML = e.innerHTML.replace(/\n{2,}/g, '\n');;
        var sanitized = temp.textContent || temp.innerText;
        sanitized = sanitized.replace(/\n\s*\n/g, '\n');
        dt.setData("text/plain", sanitized);

        //get the html version
        var rx=new RegExp("<i[^>]*>(.*?)</i>", "gm");
        s=s.replace(rx,"");
        dt.setData("text/html", s);

        clipboard.write(dt);
    
        this._notificationsService.add(new Notification('success', 'Contact has been copied to the clipboard.'));
    }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/address-book/address-book.component.ts